import useOnboardingGuard from "./useOnboardingGuard";
import React from "react";

export const OnboardingGuard = ({ children }) => {
  const { grantAccess } = useOnboardingGuard();

  return <>{grantAccess && children}</>;
};
